/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {
    currentVersion: 'v1',
    endpoint: 'https://office.smartbug.cloud:60005/api',
    //endpoint: 'https://enel.smartbug.cloud:60006/api',
    //endpoint: 'http://192.168.25.80:60005/api',
  },
  socket: { // socket settings
    globalTopics: ['alerts'],
    endpoint: 'http://office.smartbug.cloud:60003'// socket endpoint
    //endpoint: 'http://enel.smartbug.cloud:60007'// socket endpoint
    //endpoint: 'http://192.168.25.80:60004',
  },
  resource:{
    baseUrl:"https://office.smartbug.cloud/"
    //baseUrl:"https://enel.smartbug.cloud/"
    //baseUrl:"http://192.168.25.80/"
  },
  toastr: { // Alert notification settings
    defaultTimeout: 6000, //default timeout before toastr disappears
    defaultStatus: 'info' // info is the defautl status (blue with a question mark icon '?') 
  }
};
